import type {
  MealCategoryId,
  SupplementFrequencyId,
  SupplementUnitId,
} from '../../types/mealTracking';

export const MEAL_TRACKING_BASE_PATH = '/diario-alimentar';

export const SUPPLEMENT_TRACKING_BASE_PATH = '/enviar-suplementos';

export const MEAL_CATEGORY_OPTIONS: { value: MealCategoryId; label: string }[] = [
  { value: 'breakfast', label: 'Café da manhã' },
  { value: 'morning_snack', label: 'Lanche da manhã' },
  { value: 'lunch', label: 'Almoço' },
  { value: 'afternoon_snack', label: 'Lanche da tarde' },
  { value: 'dinner', label: 'Jantar' },
  { value: 'supper', label: 'Ceia' },
  { value: 'other', label: 'Outra refeição' },
];

export const MEAL_CATEGORY_LABEL: Record<MealCategoryId, string> = MEAL_CATEGORY_OPTIONS.reduce(
  (acc, option) => {
    acc[option.value] = option.label;
    return acc;
  },
  {} as Record<MealCategoryId, string>,
);

export const ACCEPTED_MEAL_PHOTO_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

export const MAX_MEAL_PHOTOS = 6;

export const SUPPLEMENT_NAME_SUGGESTIONS = [
  'Whey Protein',
  'Creatina',
  'BCAA',
  'Glutamina',
  'Maltodextrina',
  'Pré-treino',
  'Vitaminas',
  'Ômega-3',
] as const;

export const SUPPLEMENT_UNIT_OPTIONS: { value: SupplementUnitId; label: string }[] = [
  { value: 'g', label: 'g' },
  { value: 'mg', label: 'mg' },
  { value: 'ml', label: 'ml' },
  { value: 'capsules', label: 'cápsulas' },
  { value: 'tablets', label: 'comprimidos' },
  { value: 'scoops', label: 'scoops' },
  { value: 'other', label: 'outro' },
];

export const SUPPLEMENT_UNIT_LABEL: Record<SupplementUnitId, string> = SUPPLEMENT_UNIT_OPTIONS.reduce(
  (acc, option) => {
    acc[option.value] = option.label;
    return acc;
  },
  {} as Record<SupplementUnitId, string>,
);

export const SUPPLEMENT_FREQUENCY_OPTIONS: { value: SupplementFrequencyId; label: string }[] = [
  { value: 'daily', label: 'Diário' },
  { value: 'weekly', label: 'Semanal' },
  { value: 'before_training', label: 'Antes do treino' },
  { value: 'after_training', label: 'Depois do treino' },
  { value: 'custom', label: 'Personalizado' },
];

export const SUPPLEMENT_FREQUENCY_LABEL: Record<SupplementFrequencyId, string> = (
  SUPPLEMENT_FREQUENCY_OPTIONS.reduce(
    (acc, option) => {
      acc[option.value] = option.label;
      return acc;
    },
    {} as Record<SupplementFrequencyId, string>,
  )
);
